export default "__VITE_ASSET__bbc338e4__"